<div mat-dialog-title class="dialog-title font-normal">{{ data.title }}</div>
<div mat-dialog-content>
    <p>{{ data.content }}</p>
</div>
<div mat-dialog-actions align="end" class="font-normal">
    <button mat-button class="cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-button color="primary" class="delete-button" (click)="onDelete()">Delete</button>
</div>